import React, { Fragment } from 'react';
import { Button }from '@cmsgov/design-system';

import { FormattedMessage } from 'react-intl';

// Components

import ModalHeader from '@common-components/headers/ModalHeader';



const LeavePageModal = props => {

    const {
        actions: {
            hideModal
        },
        bottomAnchors: [
            anchor_1,
        ],
        boundAnchor,
        modalHeaderProps,
        modal: {
            modalData: {
                url,
                action,
            }
        }
    } = props;

    const handleStayOnPageClick = () => {
        hideModal();
    };

    const handleLeavePageClick = () => {
        if(url) {
            window.location = url;
        } else if(action) {
            action();
            hideModal();
        }
    };

    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader { ...modalHeaderProps } />
            </div>
            <div id = 'leavePageModal' className="gi-modal__body">
                <FormattedMessage id='modals.leave_page.warning'/>
            </div>
            <div className="gi-modal__controls">
                <Button
                    className="usa-button gi-button gi-button__primary"
                    onClick={handleLeavePageClick}
                >
                    <FormattedMessage id='button.leave_page'/>
                </Button>
                <Button
                    className="usa-button usa-button--outline gi-button gi-button__outline"
                    onClick={handleStayOnPageClick}
                    inputRef={boundAnchor(anchor_1)}
                >
                    <FormattedMessage id='button.stay_on_page'/>
                </Button>
            </div>
        </Fragment>
    );
};

export default LeavePageModal;